import DialInItem from './DialInItem';

export default DialInItem;
